const PROGRAM_SPECIFIC_MIXIN = {
  computed: {
    elementActive () {
      if (this.formField.program_ids && this.formField.program_ids.length) {
        if (this.currentProgram) {
          return this.formField.program_ids.length === 0 || this.formField.program_ids.includes(this.currentProgram)
        } else {
          return false
        }
      }
      return true
    }
  }
}

export default PROGRAM_SPECIFIC_MIXIN
